module.exports = __webpack_public_path__ + "static/media/442.01243cfe.webp";